<template>
  <div class="flex flex-col gap-6">
    <!-- Large checkmark at the top -->
    <div class="flex justify-center my-2 md:my-4">
      <img src="/tick.png" alt="Checkmark" class="w-10 h-10 lg:w-16 lg:h-16" />
    </div>
    
    <!-- Main title with custom font -->
    <Typography size="main-l" class="text-center leading-none text-nowrap text-white font-bold">
      You are elegible for rewards!
    </Typography>
    
    <!-- Rewards list horizontal -->
    <div class="flex flex-row justify-center gap-8 my-6">
      <!-- Seed NFT -->
      <div class="flex items-center gap-2" :class="{ 'opacity-50': !eligibility?.nft }">
        <img src="/tick.png" alt="Checkmark" class="w-5 h-5" />
        <Typography size="secondary-lg" class="text-white">Seed NFT</Typography>
      </div>

      <!-- Apecoin -->
      <div class="flex items-center gap-2" :class="{ 'opacity-50': !eligibility?.apecoin }">
        <img src="/tick.png" alt="Checkmark" class="w-5 h-5" />
        <Typography size="secondary-lg" class="text-white">Apecoin</Typography>
      </div>

      <!-- Badges -->
      <div class="flex items-center gap-2" :class="{ 'opacity-50': !eligibility?.badge }">
        <img src="/tick.png" alt="Checkmark" class="w-5 h-5" />
        <Typography size="secondary-lg" class="text-white">Badges</Typography>
      </div>
    </div>

    <!-- Continue button -->
    <button 
      class="bg-primary text-white font-bold px-6 py-2 mx-auto w-full max-w-sm hover:bg-opacity-90 transition-all"
      @click="closeModal">
      <Typography size="main-l" class="font-bold">Continue</Typography>
    </button>
  </div>
</template>
  
<script setup>
import Typography from "@/components/common/Typography.vue"
import { useModalsStore } from '../../stores/useModalsStore'
import { computed } from 'vue'

const modalsStore = useModalsStore()

// Obtener los datos de elegibilidad del payload del modal
const eligibility = computed(() => modalsStore.modalPayload)

const closeModal = () => {
  modalsStore.openModal('WALLET_ADDRESS', eligibility.value)
}
</script>
  
<style scoped>
</style>

